import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSchool } from '../../context/SchoolContext';
import { useAuth } from '../../context/AuthContext';
import { HiOutlineCog, HiOutlineLogout } from 'react-icons/hi';
import BrandLockup from '../brand/BrandLockup';

const BADGE_COLORS = [
  { bg: 'bg-blue-100', text: 'text-blue-700' },
  { bg: 'bg-blue-100', text: 'text-blue-700' },
  { bg: 'bg-green-100', text: 'text-green-700' },
  { bg: 'bg-gray-100', text: 'text-gray-700' },
];

function Sidebar({ activeSection, setActiveSection, onSectionSelect }) {
  const { school, sections } = useSchool();
  const { signOut } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="w-64 min-h-screen bg-white border-r border-gray-100 flex flex-col shadow-sm dark:border-neutral-800 dark:bg-neutral-900 lg:h-screen lg:min-h-0 lg:overflow-hidden">

      {/* Header */}
      <div className="shrink-0 p-6 border-b border-gray-100 dark:border-neutral-800">
        <BrandLockup
          size="sm"
          title={school?.name || 'Loading...'}
        />
      </div>

      {/* Sections */}
      <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain p-4">
        <p className="text-gray-400 text-xs font-semibold uppercase tracking-widest mb-3 px-2">
          Sections
        </p>
        <div className="space-y-1">
          {sections.map((section, index) => {
            const isActive = activeSection?.id === section.id;
            const color = BADGE_COLORS[index % BADGE_COLORS.length];
            return (
              <button
                key={section.id}
                onClick={() => {
                  setActiveSection(section);
                  onSectionSelect?.();
                }}
                className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-left transition-all duration-200 ${
                  isActive
                    ? 'bg-blue-50 border border-blue-100 dark:border-neutral-700 dark:bg-neutral-800'
                    : 'hover:bg-gray-50 dark:hover:bg-neutral-800'
                }`}
              >
                <span className={`w-8 h-8 rounded-lg flex items-center justify-center text-xs font-bold shrink-0 ${
                  isActive
                    ? 'bg-blue-700 text-white'
                    : `${color.bg} ${color.text}`
                }`}>
                  {section.initials}
                </span>
                <span className={`font-medium text-sm ${
                  isActive ? 'text-blue-700 dark:text-neutral-100' : 'text-gray-600 dark:text-neutral-300'
                }`}>
                  {section.name}
                </span>
              </button>
            );
          })}
        </div>
      </div>

      {/* Footer */}
      <div className="shrink-0 p-4 border-t border-gray-100 space-y-1 dark:border-neutral-800">
        <button
          onClick={() => {
            navigate('/settings');
            onSectionSelect?.();
          }}
          className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-gray-400 hover:bg-gray-50 hover:text-gray-700 transition-all dark:hover:bg-neutral-800 dark:hover:text-neutral-200"
        >
          <HiOutlineCog className="text-lg" />
          <span className="text-sm font-medium">Settings</span>
        </button>
        <button
          onClick={async () => {
            await signOut();
            navigate('/');
          }}
          className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-gray-400 hover:bg-red-50 hover:text-red-500 transition-all dark:hover:bg-red-950 dark:hover:text-red-300"
        >
          <HiOutlineLogout className="text-lg" />
          <span className="text-sm font-medium">Sign Out</span>
        </button>
      </div>

    </div>
  );
}

export default Sidebar;
